/**
 * 投资回报预期卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, InputNumber } from 'antd';

const { TextArea } = Input;

export const InvestmentROICard: React.FC = () => {
    return (
        <Card title="💰 投资回报预期" bordered={false}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'initial_investment']}
                        label="初始投资预算"
                    >
                        <InputNumber
                            prefix="¥"
                            min={0}
                            step={1000}
                            style={{ width: '100%' }}
                            placeholder="首批投资金额"
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'expected_roi']}
                        label="预期ROI"
                    >
                        <InputNumber
                            suffix="%"
                            min={0}
                            max={1000}
                            step={10}
                            style={{ width: '100%' }}
                            placeholder="投资回报率"
                        />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        name={['research_data', 'breakeven_period']}
                        label="预计回本周期"
                    >
                        <InputNumber
                            suffix="月"
                            min={1}
                            max={36}
                            style={{ width: '100%' }}
                            placeholder="多久回本"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'financial_projection']}
                        label="财务预测"
                    >
                        <TextArea
                            rows={3}
                            placeholder="预估月销量、月销售额、利润等..."
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default InvestmentROICard;
